import { Favorite } from "@mui/icons-material";
import { useSessionContext } from "@/contexts/SessionContext";
import { IFeatures } from "@/utils/interfaces";
import { GoogleHealthPage } from "./GoogleHealthPage";

/**
 * Rota de fitness Google Health. Fora do menu lateral:
 * acesso pelo FluxHealth no app portable e atalhos do dash.
 */
export function useGoogleHealth() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access.type === "patient",
    path: "/googlehealth",
    icon: Favorite,
    text: "FluxHealth",
    component: () => <GoogleHealthPage />,
  };
  return configs;
}
